import { IconButton } from '@mui/material';
import { IconMessageCircle } from '@tabler/icons-react';
import { useDeviceContext } from 'hooks/useDeviceContext';
import { useGetUserQuery } from 'store/slices/apiV1/user';
import 'assets/scss/pylon-style-override.css';
import { PylonAction } from 'constants/pylonConstants';

const WarehouseHelpHub = () => {
  const { desktopScreen } = useDeviceContext();
  const { data: user } = useGetUserQuery();

  const handleOpenPylon = () => {
    if (window.Pylon) {
      window.Pylon(PylonAction.show);
    }
  };

  if (!user) {
    return <></>;
  }

  return (
    <IconButton
      size={desktopScreen ? 'large' : 'medium'}
      color="inherit"
      onClick={handleOpenPylon}
      aria-label="Launch HelpHub"
    >
      <IconMessageCircle size={desktopScreen ? 32 : 24} color="white" />
    </IconButton>
  );
};

export default WarehouseHelpHub;
